import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from './auth';
import { uiReducer } from './ui';

// TODO: for code splitting, how does this impact us?
export default combineReducers({
  auth: authReducer,
  ui: uiReducer,
});
